import {
  Card,
  Stat,
  StatGroup,
  StatLabel,
  StatNumber,
  VStack,
} from "@chakra-ui/react";
import { useFeeChargeEventBasisStatsRetrieve } from "gen/endpoints/fee-charge-event/fee-charge-event";
import React from "react";
import { CardSectionBody } from "shared/components/card/CardSection";
import { useRequiredStringParams } from "shared/hooks/useRequiredStringParams";
import { formatMoney } from "shared/utils/MoneyUtils";

export const FeeBasisStats: React.FC<{
  feeChargeEventSelected: string;
}> = ({ feeChargeEventSelected }) => {
  const { fundFamilyId } = useRequiredStringParams();

  const { data: statsData } = useFeeChargeEventBasisStatsRetrieve(
    fundFamilyId,
    feeChargeEventSelected,
  );

  return (
    <VStack spacing="12px" mb="12px" alignItems="stretch">
      {statsData?.basis_id_to_basis_stats &&
        Object.values(statsData.basis_id_to_basis_stats).map((basis_stats) => (
          <Card variant="stat" key={basis_stats.name}>
            <CardSectionBody mb="16px" mt="16px">
              <StatGroup alignItems="center" justifyItems="center" ml="24px">
                <Stat size="sm">
                  <StatNumber fontSize="24px">
                    {formatMoney(basis_stats.total_basis)}
                  </StatNumber>
                  <StatLabel>{basis_stats.name}</StatLabel>
                </Stat>
                {Object.values(basis_stats.basis_category_to_stats).map(
                  (basis_category_stats) => (
                    <Stat size="sm" key={basis_category_stats.name}>
                      <StatNumber fontSize="16px">
                        {formatMoney(basis_category_stats.total_basis)}
                      </StatNumber>
                      <StatLabel>{basis_category_stats.name}</StatLabel>
                    </Stat>
                  ),
                )}
              </StatGroup>
            </CardSectionBody>
          </Card>
        ))}
    </VStack>
  );
};
